import Vue from 'vue';
import Vuex from 'vuex';
import { Module } from './store-builder';

Vue.use(Vuex);

function getFilenameFromPath (path: string): string {
  const file = path.split(/[/\\]/).pop();
  return file.replace(/\..+?$/, '');
}
const requireModules = require.context(
  // The relative path of the components folder
  './modules',
  // Whether or not to look in subfolders
  true,
  // The regular expression used to match base component filenames
  /\.(ts|js)$/
);
const modules: { [key: string]: Module } = {};
requireModules.keys().map(fileName => {
  // Get component config
  const module = requireModules(fileName).default;
  if (module) {
    const name = module.name || getFilenameFromPath(fileName);

    modules[name] = module;
  } else {
    // eslint-disable-next-line no-console
    console.error('Vuex store module : No "export default" found in file ' + fileName);
  }
});

const DEBUG = true; // dont forget to enable 'verbose' in chrome's console
if (!!DEBUG === true && process.env.NODE_ENV !== 'production') {
  /* eslint-disable no-console */
  console.debug('registered vuex modules :', Object.keys(modules));
  Object.keys(modules).forEach(key => {
    const values = {
      states: Object.keys(modules[key].state).map(name => key + '/' + name),
      getters: Object.keys(modules[key].getters).map(name => key + '/' + name),
      actions: Object.keys(modules[key].actions).map(name => key + '/' + name),
      mutations: Object.keys(modules[key].mutations).map(name => key + '/' + name)
    };
    console.debug('vuex module ' + key, values);
  });
  /* eslint-enable no-console */
}

const store = new Vuex.Store({
  modules: modules as any,
  actions: {
    reset () {
      window.sessionStorage.clear();
      for (const key in modules) {
        const module = modules[key];
        if (module.actions.reset) {
          (this as any).dispatch(key + '/reset');
        } else {
          // eslint-disable-next-line no-console
          console.warn('no reset action for module ' + key);
        }
      }
    }
  },
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== 'production'
});

export default store;
